import BasicInitializationService from "../../services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import ChargeTypesViewModel from "../../viewModels/chargeTypes/chargeTypesViewModel";
import { registerWidget } from "../widget";

const ChargeTypesWidgetIdentifier = "edaz-charge-types";

registerWidget({
  component: makeWidgetFor(ChargeTypesWidgetIdentifier, [ChargeTypesViewModel], BasicInitializationService),
  configuration: {
    tagname: ChargeTypesWidgetIdentifier,
  },
});
